import { shouldTableSortByRenewTime } from 'owa-mail-list-response-processor';
import { MailSortHelper } from 'owa-mail-list-store';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import sortResults from 'owa-service/lib/factory/sortResults';
/**
 * Gets the sortByResults property
 * @param tableQuery tableQuery of the conversation type table for which to get the sortBy property
 * @return sortByResults - a collection of the sort properties
 */
export default function getConversationSortByProperty(tableQuery) {
    var sortBy = tableQuery.sortBy;
    var primarySortPropertyUri;
    switch (tableQuery.sortBy.sortColumn) {
        case 0 /* Date */:
            if (shouldTableSortByRenewTime(tableQuery)) {
                primarySortPropertyUri = 'ConversationLastDeliveryOrRenewTime';
            }
            break;
        case 1 /* From */:
            primarySortPropertyUri = 'ConversationUniqueSenders';
            break;
        case 2 /* Size */:
            primarySortPropertyUri = 'ConversationSize';
            break;
        default:
            throw new Error('getConversationSortByProperty: sort column is not supported ' + sortBy.sortColumn);
    }
    // Add primary SortResult
    var sortByResults = [];
    if (primarySortPropertyUri) {
        sortByResults.push(sortResults({
            Order: sortBy.sortDirection,
            Path: propertyUri({ FieldURI: primarySortPropertyUri }),
        }));
    }
    // For non-date sorts the secondary sort direction will always default to descending.
    // For date sort we want to honour users selection of direction
    var secondarySortDirection = tableQuery.sortBy.sortColumn == 0 /* Date */
        ? tableQuery.sortBy.sortDirection
        : MailSortHelper.DESCENDING_SORT_DIR;
    // Add secondary SortResult of ConversationLastDeliveryTime for all sort types.
    // Currently only descending sort order is supported
    sortByResults.push(sortResults({
        Order: secondarySortDirection,
        Path: propertyUri({ FieldURI: 'ConversationLastDeliveryTime' }),
    }));
    return sortByResults;
}
//# sourceMappingURL=getConversationSortByProperty.js.map